import React from 'react';
import TopoSemMenuLogin from '../../components/TopoSemMenuLogin';
import FormRecadastrar from './components/FormRecadastrar';

export default class Login extends React.Component {
  render() {
    return (
      <div>
        <TopoSemMenuLogin/>
        <FormRecadastrar location={this.props.location}/>
      </div>
    );
  }
}